import EventViewPageHeader from './EventViewPageHeader';

export default EventViewPageHeader;
